import { Container } from "~/components/landingpage/Container";
import { PricingCard } from "~/components/landingpage/PricingCard";
import { SectionTitle } from "~/components/landingpage/SectionTitle";

export default function Pricing() {
  return (
    <Container className="flex w-full flex-col items-center justify-center">
      <SectionTitle preTitle="Preise" title="Wähle den passenden Plan für dich">
        Starte kostenlos und upgrade jederzeit auf mehr Credits. Keine
        versteckten Kosten, keine Überraschungen.
      </SectionTitle>

      <div className="mt-16 grid w-full max-w-5xl gap-8 px-4 md:grid-cols-2 lg:gap-12">
        <PricingCard
          title="Starter"
          price="Kostenlos"
          description="Perfekt zum Testen und für gelegentliche Nutzung"
          features={[
            "5 Credits pro Monat",
            "Zugang zu allen Features",
            "KI-gestützte Bewerbungsoptimierung",
            "Profilanalyse",
          ]}
          ctaText="Jetzt starten"
          ctaLink="/app"
        />
        <PricingCard
          title="Professional"
          price="5€"
          description="Für aktive Freelancer mit mehr Bewerbungen"
          features={[
            "15 Credits gültig für 30 Tage",
            "Zugang zu allen Features",
            "KI-gestützte Bewerbungsoptimierung",
            "Profilanalyse",
            "Prioritäts-Support",
          ]}
          ctaText="Upgrade"
          ctaLink="/app/settings"
          highlighted={true}
        />
      </div>
    </Container>
  );
}
